import http from 'utils/http';
import { TeamMember, TeamMemberRequest } from './types';
import { getTeamMembersUrl, getTeamMemberUrl } from './apiUrls';
import { MetaApiResponse } from 'utils/types/CommonApiResponse';

export function getTeamMembers(params: any): Promise<{ data: TeamMember[]; meta: MetaApiResponse }> {
  return http.get(getTeamMembersUrl(), params);
}

export function getTeamMember(id: string, params?: Record<string, any>): Promise<TeamMember> {
  return http.get(getTeamMemberUrl(id), params);
}

export function createTeamMember(payload: TeamMemberRequest): Promise<TeamMember> {
  return http.post(getTeamMembersUrl(), payload);
}

export function updateTeamMember(id: string, payload: TeamMemberRequest): Promise<TeamMember> {
  return http.patch(getTeamMemberUrl(id), payload);
}

export function deleteTeamMember(id: string): Promise<String> {
  return http.delete(getTeamMemberUrl(id));
}
